/**
 * @generated SignedSource<<05bc1aeb9d70807463f6bf4ba11432ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductAppKind = "chat_channel" | "collection" | "content" | "curriculum" | "dashboard" | "events" | "group_directory" | "link" | "member_directory" | "members" | "nav_folder" | "organization_events" | "organization_members" | "posts" | "product_link" | "resources" | "slack" | "%future added value";
export type ProductStatus = "archived" | "draft" | "published" | "unlisted" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ChannelsSidebarProductFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly productApps: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly customAppTitle: string | null;
        readonly id: string;
        readonly kind: ProductAppKind;
        readonly productApps: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly chatChannel: {
                readonly externalChannelId: string;
              } | null;
              readonly id: string;
              readonly " $fragmentSpreads": FragmentRefs<"ChatChannelSideBarItemFragment">;
            };
          }>;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"AppSidebarItemFragment" | "ChatChannelSideBarItemFragment">;
      };
    }>;
  };
  readonly slug: string;
  readonly status: ProductStatus;
  readonly " $fragmentSpreads": FragmentRefs<"ProductBadgeFragment">;
  readonly " $fragmentType": "ChannelsSidebarProductFragment";
};
export type ChannelsSidebarProductFragment$key = {
  readonly " $data"?: ChannelsSidebarProductFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChannelsSidebarProductFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "ChatChannelSideBarItemFragment"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChannelsSidebarProductFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "kinds",
          "value": [
            "chat_channel",
            "nav_folder"
          ]
        }
      ],
      "concreteType": "ProductAppNodeConnection",
      "kind": "LinkedField",
      "name": "productApps",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductAppNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductApp",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "kind",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "customAppTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "kinds",
                      "value": [
                        "chat_channel"
                      ]
                    }
                  ],
                  "concreteType": "ProductAppNodeConnection",
                  "kind": "LinkedField",
                  "name": "productApps",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProductAppNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ProductApp",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "ChatChannel",
                              "kind": "LinkedField",
                              "name": "chatChannel",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "externalChannelId",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            (v1/*: any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "productApps(kinds:[\"chat_channel\"])"
                },
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "AppSidebarItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "productApps(kinds:[\"chat_channel\",\"nav_folder\"])"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductBadgeFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};
})();

(node as any).hash = "1f767b491caecfed59d3222865ee06b8";

export default node;
